
import * as orderTypeEnum from '~/enums/order-type'
import { isBuyOrder } from '~/utils/order-type'
import { types as productTypes } from '~/utils/product-item-type'
import OrderSummary from '~/components/create-order/order-summary.vue'
import PartialSellMessages from '~/components/create-order/sell/partial-sell-messages.vue'

export default {
  components: {
    OrderSummary,
    PartialSellMessages,
  },
  props: {
    itemType: {
      type: String,
      required: true,
      validator: (val) => Object.values(productTypes).includes(val),
    },
    orderType: {
      type: String,
      required: true,
      validator: (val) =>
        [orderTypeEnum.values.Buy, orderTypeEnum.values.Sell].includes(val),
    },
    periodOptions: {
      type: Array,
      required: true,
    },
    minPrice: {
      type: Number,
      default: 1.0,
    },
    maxPrice: {
      type: Number,
      default: null,
    },
    maxQuantity: {
      type: Number,
      default: null,
    },
    quantityOnSellOrders: {
      type: Number,
      default: 0,
    },
    quantityBlocked: {
      type: Number,
      default: 0,
    },
    formData: {
      type: Object,
      required: true,
    },
    showRoi: {
      type: Boolean,
      required: false,
    },
    itemId: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      quantity: this.formData.quantity,
      unitPrice: this.formData.unitPrice,
      durationInDays: this.formData.durationInDays,
    }
  },
  computed: {
    quantityLabel() {
      return this.$isCask({ itemType: this.itemType })
        ? this.$gettext('Number of bottles from cask')
        : this.$gettext('Number of bottles')
    },

    priceRangeOverflowMessage() {
      return this.maxPrice
        ? this.$gettext(
            'Value must be less than or equal to %s',
            this.$formatAsCurrency(this.maxPrice),
          )
        : null
    },

    priceRangeUnderflowMessage() {
      return this.minPrice
        ? this.$gettext(
            'Value must be more than %s',
            this.$formatAsCurrency(this.minPrice),
          )
        : null
    },

    orderDetails() {
      const { unitPrice, quantity } = this

      return [
        {
          price: unitPrice,
          quantity,
          subTotal: unitPrice * quantity,
        },
      ]
    },

    isOrderTypeBuy() {
      return isBuyOrder(this.orderType)
    },
  },

  watch: {
    quantity(newValue) {
      this.$emit('update:formData', {
        ...this.formData,
        quantity: newValue,
      })
    },

    unitPrice(newValue) {
      this.$emit('update:formData', {
        ...this.formData,
        unitPrice: newValue,
      })
    },

    durationInDays(newValue) {
      this.$emit('update:formData', {
        ...this.formData,
        durationInDays: newValue,
      })
    },
  },

  methods: {
    close() {
      this.$emit('close')
    },
  },
}
